import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText,
  MDBCheckbox


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';



function EditarFilial() {
  const navigate = useNavigate();
  const [filiais, setFiliais] = useState([]);
  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/filial')
  const {id} = useParams();

  const [formValue, setFormValue] = useState({
    id: '',
    idFilial: '',
    nomeFilial: '', 
    senha: '', 
    latitude: '',
    longitude: '',
    raio: '',
  });

  const [checked, setChecked] = useState(false);

  const handleSubmit = async (values) => {
    console.log(formValue);
    values.preventDefault();
    util.isSubmitting()
    const result = await api.atualizarFilialApi(formValue);
    result ? toast.success("Atualizado com sucesso!") && navigate("/area-filial") : null;
    util.isSubmitting()
    
  }

  const handleDelet = async () => {
    const object = {
        id: id
    }
    util.isSubmitting()
    const result = await api.excluirFilialApi(object);
    result ? toast.success("Excluido com sucesso!") && navigate("/area-filial") : null;
    util.isSubmitting()
    
  }

  useEffect(() => {
    const getFilial = async () => {
      try {
        const object = {
          id: id,
        };
        const response = await api.pegarFilialApi(object);
        const data = await response;
        
        setFiliais(data[0]);
        console.log(data[0]);
        setFormValue({
          id: id,
          idFilial: data[0].idfilial, 
          nomeFilial: data[0].nomefilial, 
          senha: data[0].senha, 
          latitude: data[0].latitude,
          longitude: data[0].longitude,
          raio: data[0].raio,
        });
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };

    getFilial();
  }, [id]);

  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
       minHeight:'500',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column align-items-center'>

          <MDBCard className='bg-dark text-white w-50' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white mb-5'>Bem vindo, {util.decideName(userLogin)}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={!checked ? handleSubmit : handleDelet}>
                    <MDBValidationItem feedback='Por favor digite nome da filial!' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Nome da filial' 
                        name='nomeFilial'
                        id='formControNomeFilial' 
                        type='text' 
                        size="lg"
                        value={formValue.nomeFilial || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite o login' style={{opacity:0.4}}invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100'
                        className='bg-dark' 
                        labelClass='text-white' 
                        label='Login' 
                        name='login'
                        id='formControLogin' 
                        type='text' 
                        size="lg"
                        value={filiais.login || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        disabled={true}
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite o senha'invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100'
                        className='bg-dark' 
                        labelClass='text-white' 
                        label='Senha' 
                        name='senha'
                        id='formControSenha' 
                        type='password' 
                        size="lg"
                        value={formValue.senha || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite a latitude' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Latitude' 
                        name='latitude'
                        id='formControLatitude' 
                        type='text' 
                        size="lg"
                        value={formValue.latitude || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite a longitude' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Longitude' 
                        name='longitude' 
                        id='formControMatriculaLongitude' 
                        type='text' 
                        size="lg"
                        value={formValue.longitude || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite o raio' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Raio' 
                        name='raio'
                        id='formControRaio' 
                        type='text' 
                        size="lg"
                        value={formValue.raio || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    
                    
                    <div className='my-2'>
                        <MDBCheckbox

                            id='controlledCheckbox'
                            label='Habilitar botão "Exluir"'
                            checked={checked}
                            onChange={() => setChecked(!checked)}
                        />
                    </div>
                    <div className='d-flex justify-content-between align-items-center flex-column'>
                        <MDBBtn 
                            outline 
                            className='my-3 btn-home w-100' 
                            color='white' 
                            size='lg'
                            type='submit'   
                            id='submitForm'  
                            disabled={!checked}                 
                            >
                            
                            excluir
                        </MDBBtn>
                        <MDBBtn 
                            outline 
                            className='px-5 w-100 btn-home' 
                            color='white' 
                            size='lg'
                            type='submit'   
                            id='submitForm'  
                            disabled={false}                 
                            >
                            
                            Editar
                        </MDBBtn>
                      </div>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/listar-filial")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default EditarFilial;